import { type RouterInputs, trpc } from '../lib/trpc';

export function useThread(id: number | null) {
  return trpc.threads.getById.useQuery({ id: id ?? 0 }, { enabled: !!id });
}

export function useThreadForContact(contactId: number | null) {
  return trpc.threads.getThreadForContact.useQuery(
    { contactId: contactId ?? 0 },
    { enabled: !!contactId }
  );
}

export function useThreadForAnchor(anchorId: number | null) {
  return trpc.threads.getThreadForAnchor.useQuery(
    { anchorId: anchorId ?? 0 },
    { enabled: !!anchorId }
  );
}

export function useThreadForPin(pinId: number | null) {
  return trpc.threads.getThreadForPin.useQuery({ pinId: pinId ?? 0 }, { enabled: !!pinId });
}

export function useThreadForTask(taskId: number | null) {
  return trpc.threads.getThreadForTask.useQuery({ taskId: taskId ?? 0 }, { enabled: !!taskId });
}

export function useThreadForJob(jobId: number | null) {
  return trpc.threads.getThreadForJob.useQuery({ jobId: jobId ?? 0 }, { enabled: !!jobId });
}

export function useThreadForEmailThread(emailThreadId: string | null) {
  return trpc.threads.getThreadForEmailThread.useQuery(
    { emailThreadId: emailThreadId ?? '' },
    { enabled: !!emailThreadId }
  );
}

export function useCreateThread() {
  const utils = trpc.useUtils();

  return trpc.threads.create.useMutation({
    onSuccess: (res) => {
      utils.threads.getAll.invalidate();
      utils.threads.getCounts.invalidate();
      if (res.thread?.contactId)
        utils.threads.getThreadForContact.invalidate({ contactId: res.thread.contactId });
      if (res.thread?.anchorId)
        utils.threads.getThreadForAnchor.invalidate({ anchorId: res.thread.anchorId });
      if (res.thread?.pinId) utils.threads.getThreadForPin.invalidate({ pinId: res.thread.pinId });
      if (res.thread?.taskId)
        utils.threads.getThreadForTask.invalidate({ taskId: res.thread.taskId });
      if (res.thread?.jobId) utils.threads.getThreadForJob.invalidate({ jobId: res.thread.jobId });
      if (res.thread?.emailThreadId)
        utils.threads.getThreadForEmailThread.invalidate({
          emailThreadId: res.thread.emailThreadId,
        });
    },
  });
}

export function useUpdateThread() {
  const utils = trpc.useUtils();

  return trpc.threads.update.useMutation({
    onSuccess: (_, variables: RouterInputs['threads']['update']) => {
      utils.threads.getAll.invalidate();
      utils.threads.getById.invalidate({ id: variables.id });
    },
  });
}

export function useTogglePin() {
  const utils = trpc.useUtils();

  return trpc.threads.update.useMutation({
    onSuccess: (res) => {
      utils.threads.getAll.invalidate();
      if (res.thread) utils.threads.getById.invalidate({ id: res.thread.id });
    },
  });
}

export function useDeleteThread() {
  const utils = trpc.useUtils();

  return trpc.threads.delete.useMutation({
    onSuccess: () => {
      utils.threads.getAll.invalidate();
      utils.threads.getCounts.invalidate();
      utils.threads.getById.invalidate();
    },
  });
}
